import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TRANSLATIONS from '_translations/keys';

class T extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showKeys: false,
    };

    if (TRANSLATIONS.find(x => x.toLowerCase() === props.resourceString.toLowerCase()) === undefined) {
      throw new Error(`Using resource string "${props.resourceString}" without adding it to /src/js/translations/keys.js`);
    }

    window.addEventListener('keypress', this.toggleShowKeys);
  }

  render() {
    if (this.props.translations.isLoading === true) {
      return null;
    }

    if (this.state.showKeys === true) {
      return (
        <div className="resource-string-tooltip">
          <span>{this.props.resourceString}</span>
          {this.renderResourceString()}
        </div>
      );
    }

    return this.renderResourceString();
  }

  renderResourceString = () => {
    const translatedValue = this.props.translations.keys[this.props.resourceString.toLowerCase()];

    if (this.props.renderAsHtml === true) {
      return <React.Fragment><span dangerouslySetInnerHTML={{ __html: translatedValue }}></span></React.Fragment>;
    }

    return <React.Fragment>{translatedValue}</React.Fragment>;
  }

  toggleShowKeys = (event) => {
    if (event.keyCode !== 96) {
      return;
    }

    this.setState({
      showKeys: !this.state.showKeys,
    });
  }
}

T.propTypes = {
  resourceString: PropTypes.string.isRequired,
  renderAsHtml: PropTypes.bool,
};

const mapStateToProps = state => ({
  translations: state.app.translations,
});

export default connect(mapStateToProps, null)(T);
